import _descriptors from "../internals/descriptors";
import _defineBuiltInAccessor from "../internals/define-built-in-accessor";
import _arrayBufferIsDetached from "../internals/array-buffer-is-detached";
var DESCRIPTORS = _descriptors;
var defineBuiltInAccessor = _defineBuiltInAccessor;
var isDetached = _arrayBufferIsDetached;
var ArrayBufferPrototype = ArrayBuffer.prototype;

// `ArrayBuffer.prototype.detached` getter
// https://tc39.es/ecma262/#sec-get-arraybuffer.prototype.detached
if (DESCRIPTORS && !("detached" in ArrayBufferPrototype)) {
  defineBuiltInAccessor(ArrayBufferPrototype, "detached", {
    configurable: true,
    get: function detached() {
      return isDetached(this);
    }
  });
}
export default {};